import { gql } from '@apollo/client'

export const BookingDriverFragment = gql`
  fragment BookingDriverFragment on BookingDriver {
    id
    charge
    extraPayment
    createdAt
    allocationStatus
    bookingId
    booking {
      id
      status
      statusLabel
      ourReference
    }
    totalCharge
    driverNotes
    reference
    rating
    xeroPurchaseCode
    isShownInstruction
    instruction
    driver {
      id
      name
      driverType
      primaryDriverId
      primaryDriverName
      identityUserName
      isUsingInternalApp
      primaryDriver {
        id
        name
      }
    }
    vehicle {
      id
      registrationNumber
      vehicleType {
        id
        name
      }
    }
    currency {
      id
      code
    }
  }
`
